import ScrollToTop from './components/ScrollToTop'
import Routes from 'routes'
import ErrorBoundary from 'ErrorBoundary'
import NavigationScroll from 'layout/NavigationScroll'
import Toast from 'components/Toast'

const App = () => {
    return (
        <ErrorBoundary>
            <NavigationScroll>
                <Toast />
                <ScrollToTop />
                <Routes />
            </NavigationScroll>
        </ErrorBoundary>
    )
}

export default App
